// Report flow item aktivite akisi — comment feed benzeri kullanim.
// Trigger otomatik yazar; hook sadece okur ve column adlarini id'lerden
// resolve eder (from/to human-readable label).

import { useCallback, useEffect, useState } from 'react';
import { hasuraClient } from '../utils/graphqlClient';
import {
  GET_REPORT_FLOW_ITEM_ACTIVITIES,
  GET_REPORT_FLOW_COLUMN_NAMES,
} from '../graphql/queries/reportFlowActivities';

export const useReportFlowItemActivities = (itemId) => {
  const [activities, setActivities] = useState([]);
  const [columnNames, setColumnNames] = useState({}); // { [id]: 'Ad' }
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!itemId) { setActivities([]); return; }
    setLoading(true);
    try {
      const res = await hasuraClient.query(GET_REPORT_FLOW_ITEM_ACTIVITIES, {
        itemId: parseInt(itemId, 10),
      });
      const rows = res?.report_flow_item_activities || [];
      setActivities(rows);

      // column_moved icin from/to id'leri (TEXT olarak saklandi, INTEGER'a
      // cast edip column tablosundan isim cek).
      const colIds = new Set();
      rows.forEach(a => {
        if (a.activity_type === 'column_moved') {
          const from = parseInt(a.from_value, 10);
          const to   = parseInt(a.to_value, 10);
          if (Number.isFinite(from)) colIds.add(from);
          if (Number.isFinite(to))   colIds.add(to);
        }
      });
      if (colIds.size > 0) {
        const nameRes = await hasuraClient.query(GET_REPORT_FLOW_COLUMN_NAMES, {
          ids: [...colIds],
        });
        const map = {};
        for (const c of (nameRes?.report_flow_columns || [])) map[c.id] = c.column_title;
        setColumnNames(map);
      } else {
        setColumnNames({});
      }
    } finally { setLoading(false); }
  }, [itemId]);

  useEffect(() => { void refetch(); }, [refetch]);

  return { activities, columnNames, loading, refetch };
};
